import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { linkFor, pageLanguage } from '../content/publicLanguages';
import { useTranslation } from 'react-i18next';

const PublicFooter = () => {
  const { t, i18n } = useTranslation();
  const language = pageLanguage(useLocation().pathname, i18n);

  return (
    <footer className="footer">
      <div className="footer-inner footer-inner--stack">
        <div className="footer-brand">
          <img src="/Logo.png" alt="UpyaChat logo" className="navbar-logo" />
          <span className="navbar-name">UpyaChat</span>
        </div>

        <nav className="footer-links" aria-label={t('public.footer.aria')}>
          <Link to={linkFor('/blog', language)}>{t('public.nav.blog')}</Link>
          <Link to="/terms">{t('public.footer.terms')}</Link>
          <Link to="/privacy">{t('public.footer.privacy')}</Link>
          <Link to="/login">{t('public.nav.login')}</Link>
        </nav>

        <p className="footer-copy">{t('public.footer.copy')}</p>
      </div>
    </footer>
  );
};

export default PublicFooter;
